import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SharePanelProps} from '@Panels/share-panel/share-panel.types';
import {SHARE_PANEL_ID, ShareItemType} from '@Panels/share-panel/share-panel.types';
import type {CollabOpenedSource} from '@Libraries/ga-events';
import {GA4EventName, GA4EventParamName} from '@Libraries/ga-events';

export const openSharingModal = (props: SharePanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SHARE_MODAL,
      panelProps: props,
    })
  );
};

/**
 * Reports a design share dialog opening.
 * @param source where the dialog opened from
 */
export const trackShareDesignDialogOpened = (source: CollabOpenedSource): void => {
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.COLLABORATION_DESIGN_OPENED, {[GA4EventParamName.SOURCE]: source});
};

/**
 * Reports a folder share dialog opening.
 * @param source where the dialog opened from
 */
export const trackShareFolderDialogOpened = (source: CollabOpenedSource): void => {
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.COLLABORATION_FOLDER_OPENED, {[GA4EventParamName.SOURCE]: source});
};

export const openPosterSharingModal = (posterHashedId: string, source: CollabOpenedSource): void => {
  trackShareDesignDialogOpened(source);
  openSharingModal({itemHashedId: posterHashedId, type: ShareItemType.POSTER, panelId: SHARE_PANEL_ID});
};

export const openFolderSharingModal = (folderHashedId: string, source: CollabOpenedSource): void => {
  trackShareFolderDialogOpened(source);
  openSharingModal({itemHashedId: folderHashedId, type: ShareItemType.FOLDER, panelId: SHARE_PANEL_ID});
};
